import React, { Component } from "react";
import fire from '../fire';
import TriviaGame from "./TriviaGame";
import { Grid, Dropdown, Message, Icon } from "semantic-ui-react";

class TriviaViewer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      triviaTopics:[],
      activeTriviaTopic: undefined,
      activeTriviaNumber: undefined,
      activeTriviaName: undefined,
      activeTriviaRandomizeQuestionsFlag: true,
      activeTriviaQuestions: [],
      isDropdownOneDisabled: false,
      isDropdownTwoDisabled: false,
      availableFields:{
        trivias:[]
      }
    };
  }

  componentDidMount() {
  
    const triviaTopicsRef = fire.database().ref('triviaTopics');

    triviaTopicsRef.once('value', snapshot => {
      let triviaTopics = snapshot.val();
      let newState = [];

      for (let item in triviaTopics) {
        newState.push({
          id: item,
          name: triviaTopics[item].name,
          number: triviaTopics[item].number,
          trivias: triviaTopics[item].trivias
        });
      }

      newState.sort(function(a, b){return a.number-b.number});

      this.setState({
        triviaTopics: newState
      });
    });
  }

  selectTriviaTopic = (name, trivias) => {
    trivias.sort(function(a, b){return a.number-b.number});
    this.setState({
        isDropdownOneDisabled: true,
        activeTriviaTopic: name,
        availableFields:{
          trivias: trivias
        }
    })
  }

  selectTrivia = (name, questions, randomizeQuestions) => {
    //reload State
    this.setState({
      isDropdownTwoDisabled: true,
      activeTriviaName: name,
      activeTriviaQuestions: questions,
      activeTriviaRandomizeQuestionsFlag: randomizeQuestions,
    })
  }

  render(){
    return(
      <Grid stackable textAlign="center" verticalAlign="middle">
          <Grid.Column width={4}>
            <Dropdown selection text={this.state.activeTriviaTopic === undefined ? "Select Trivia Topic" : this.state.activeTriviaTopic}>
              <Dropdown.Menu>
                  {
                      this.state.triviaTopics.map(triviaTopic => (
                          <Dropdown.Item disabled={this.state.isDropdownOneDisabled} key={triviaTopic.id} text={triviaTopic.name} onClick={() => this.selectTriviaTopic(triviaTopic.name, triviaTopic.trivias)} />
                      ))
                  }
              </Dropdown.Menu>
            </Dropdown>
          </Grid.Column>
          <Grid.Column width={4}>
            <Dropdown scrolling selection disabled={this.state.activeTriviaTopic === undefined ? true : false} text={this.state.activeTriviaName === undefined ? "Select Trivia" : this.state.activeTriviaName}>
              <Dropdown.Menu>
                  {
                      this.state.availableFields.trivias.map(trivia => (
                          <Dropdown.Item disabled={this.state.isDropdownTwoDisabled} key={trivia.number} text={`${trivia.number} - ${trivia.name}`} onClick={() =>this.selectTrivia(trivia.name, trivia.questions, trivia.randomizeQuestions)} />
                      ))
                  }
                </Dropdown.Menu>
              </Dropdown>            
          </Grid.Column>
          <Grid.Column width={15}>
            {
              this.state.activeTriviaName === undefined ?
                <Message color="black" icon floating>
                  <Icon name='setting' />
                  <Message.Content>
                      <Message.Header>Please select from the options above to display Trivia!</Message.Header>
                  </Message.Content>
                </Message> 
              :
              <TriviaGame key="TriviaGame" Questions={this.state.activeTriviaQuestions} Randomize={this.state.activeTriviaRandomizeQuestionsFlag} Name={`${this.state.activeTriviaTopic}: ${this.state.activeTriviaName}`} />
            }
          </Grid.Column>
      </Grid>
    );
  }
}
export default TriviaViewer;